import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import CompetitionWinner from './components/CompetitionWinner';
import Features from './components/Features';
import CarriersSection from './components/CarriersSection';
import ComplianceServicesStrip from './components/ComplianceServicesStrip';
import InsuranceQuotesStrip from './components/InsuranceQuotesStrip';
import TruckFactoryStrip from './components/TruckFactoryStrip';
import Testimonials from './components/Testimonials';
import GalleryPage from './components/GalleryPage';
import CargoCategories from './components/CargoCategories';
import Gallery from './components/Gallery';
import PromoModal from './components/PromoModal';
import IOSInstallPrompt from './components/IOSInstallPrompt';
import Footer from './components/Footer';
import { SocialFollowBar } from './components/SocialButtons';
import LiveStats from './components/LiveStats';
import RequestQuote from './pages/RequestQuote';
import LoadDetails from './pages/LoadDetails';
import SignUp from './pages/SignUp';
import BrowseLoads from './pages/BrowseLoads';
import AdminDashboard from './pages/AdminDashboard';
import CarrierDashboard from './pages/CarrierDashboard';
import CMSAdmin from './pages/CMSAdmin';
import AdminLoads from './pages/AdminLoads';
import AdminUsers from './pages/AdminUsers';
import AdminPilots from './pages/AdminPilots';
import AdminTransporterListings from './pages/AdminTransporterListings';
import AdminPilotAvailability from './pages/AdminPilotAvailability';
import AdminPilotApprovals from './pages/AdminPilotApprovals';
import ComplianceServices from './pages/ComplianceServices';
import InsuranceQuotes from './pages/InsuranceQuotes';
import AdminCraneRequests from './pages/AdminCraneRequests';
import AdminHotshots from './pages/AdminHotshots';
import AdminRouteSurveys from './pages/AdminRouteSurveys';
import PilotRegistration from './pages/PilotRegistration';
import PilotDashboard from './pages/PilotDashboard';
import AdminPilotRegistrations from './pages/AdminPilotRegistrations';
import AdminPilotAccreditations from './pages/AdminPilotAccreditations';
import TrailerHire from './pages/TrailerHire';
import TrailerHireDetail from './pages/TrailerHireDetail';
import ListTrailer from './pages/ListTrailer';
import PilotCourses from './pages/PilotCourses';
import CarrierTrailerHireBookings from './pages/CarrierTrailerHireBookings';
import TedsTravels from './pages/TedsTravels';
import AdminTedsTravels from './pages/AdminTedsTravels';
import AdminAnalytics from './pages/AdminAnalytics';
import AdminGallery from './pages/AdminGallery';
import AdminAnnouncements from './pages/AdminAnnouncements';
import AdminPromoCodes from './pages/AdminPromoCodes';
import AdminLogin from './pages/AdminLogin';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import MySubscription from './pages/MySubscription';
import BookPilot from './pages/BookPilot';
import BookRouteSurvey from './pages/BookRouteSurvey';
import RequestCraneQuote from './pages/RequestCraneQuote';
import RequestHotshot from './pages/RequestHotshot';
import ShipperDashboard from './pages/ShipperDashboard';
import TruckCompetition from './pages/TruckCompetition';
import AdminCompetition from './pages/AdminCompetition';
import AdminActiveQuotes from './pages/AdminActiveQuotes';
import AdminQA from './pages/AdminQA';
import AdminNegotiations from './pages/AdminNegotiations';
import PilotsAvailable from './pages/PilotsAvailable';
import AdminPilotEnquiries from './pages/AdminPilotEnquiries';
import AdminFAQs from './pages/AdminFAQs';
import AdminTransactions from './pages/AdminTransactions';
import AdminReviews from './pages/AdminReviews';
import Transporters from './pages/Transporters';
import JoinPage from './pages/JoinPage';

import FAQSection from './components/FAQSection';

const TedsTravelsLink = () => (
  <div className="bg-[#1e3a5f] py-10">
    <div className="container mx-auto px-4 text-center">
      <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">Truckn Ted&apos;s Travels</h2>
      <p className="text-blue-200 mb-5 max-w-lg mx-auto">Follow Ted&apos;s adventures on the road across Australia — photos, stories and life behind the wheel.</p>
      <a href="/teds-travels" className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors" data-testid="teds-travels-link">
        View the Album
      </a>
    </div>
  </div>
);

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <ComplianceServicesStrip />
      <InsuranceQuotesStrip />
      <TruckFactoryStrip />
      <SocialFollowBar />
      <CompetitionWinner />
      <Features />
      <CarriersSection />
      <Testimonials />
      <TedsTravelsLink />
      <CargoCategories />
      <FAQSection />
      <Footer />
      <PromoModal />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster />
      <IOSInstallPrompt />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/compliance" element={<ComplianceServices />} />
          <Route path="/insurance-quotes" element={<InsuranceQuotes />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/request-quote" element={<RequestQuote />} />
          <Route path="/load/:loadId" element={<LoadDetails />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/browse-loads" element={<BrowseLoads />} />
          <Route path="/book-pilot" element={<BookPilot />} />
          <Route path="/book-route-survey" element={<BookRouteSurvey />} />
          <Route path="/request-crane-quote" element={<RequestCraneQuote />} />
          <Route path="/request-hotshot" element={<RequestHotshot />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/content" element={<CMSAdmin />} />
          <Route path="/admin/announcements" element={<AdminAnnouncements />} />
          <Route path="/admin/loads" element={<AdminLoads />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/pilots" element={<AdminPilots />} />
          <Route path="/admin/transporter-listings" element={<AdminTransporterListings />} />
          <Route path="/admin/pilots/availability" element={<AdminPilotAvailability />} />
          <Route path="/admin/pilots/approvals" element={<AdminPilotApprovals />} />
          <Route path="/admin/crane-requests" element={<AdminCraneRequests />} />
          <Route path="/admin/hotshots" element={<AdminHotshots />} />
          <Route path="/admin/route-surveys" element={<AdminRouteSurveys />} />
          <Route path="/admin/pilot-registrations" element={<AdminPilotRegistrations />} />
          <Route path="/admin/pilot-accreditations" element={<AdminPilotAccreditations />} />
          <Route path="/trailer-hire" element={<TrailerHire />} />
          <Route path="/trailer-hire/:listingId" element={<TrailerHireDetail />} />
          <Route path="/list-trailer" element={<ListTrailer />} />
          <Route path="/pilot-courses" element={<PilotCourses />} />
          <Route path="/carrier/trailer-hire-bookings" element={<CarrierTrailerHireBookings />} />
          <Route path="/admin/teds-travels" element={<AdminTedsTravels />} />
          <Route path="/teds-travels" element={<TedsTravels />} />
          <Route path="/pilot-registration" element={<PilotRegistration />} />
          <Route path="/pilot-dashboard" element={<PilotDashboard />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/gallery" element={<AdminGallery />} />
          <Route path="/admin/promo-codes" element={<AdminPromoCodes />} />
          <Route path="/admin/competition" element={<AdminCompetition />} />
          <Route path="/admin/active-quotes" element={<AdminActiveQuotes />} />
          <Route path="/admin/qa" element={<AdminQA />} />
          <Route path="/admin/negotiations" element={<AdminNegotiations />} />
          <Route path="/pilots-available" element={<PilotsAvailable />} />
          <Route path="/admin/pilots/enquiries" element={<AdminPilotEnquiries />} />
          <Route path="/admin/faqs" element={<AdminFAQs />} />
          <Route path="/admin/transactions" element={<AdminTransactions />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
          <Route path="/carrier-dashboard" element={<CarrierDashboard />} />
          <Route path="/shipper-dashboard" element={<ShipperDashboard />} />
          <Route path="/subscription-success" element={<SubscriptionSuccess />} />
          <Route path="/my-subscription" element={<MySubscription />} />
          <Route path="/truck-competition" element={<TruckCompetition />} />
          <Route path="/transporters" element={<Transporters />} />
          <Route path="/join" element={<JoinPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;